import { ETurnstileErrorCode, TurnstileErrors } from '@/types/TurnstileError.types';
import { Text, VStack } from '@chakra-ui/react';
import React, { Dispatch, useState } from 'react';
import Turnstile from 'react-turnstile';

type Props = {
  turnstileToken: string | null;
  setTurnstileToken: Dispatch<React.SetStateAction<string | null>>;
  siteKey?: string;
  width?: string;
};

const TurnstileWidget = ({
  setTurnstileToken,
  siteKey = `${import.meta.env.VITE_CLOUDFLARE_TURNSTILE_SITE_KEY}`,
  width,
}: Props) => {
  const [turnstileError, setTurnstileError] = useState<ETurnstileErrorCode | null>(null);

  const onErrorHandler = (code: ETurnstileErrorCode) => {
    setTurnstileError(code);
    setTurnstileToken(null); // Reset the token on error
  };

  const onSuccessHandler = (token: string) => {
    setTurnstileError(null);
    setTurnstileToken(token);
  };

  return (
    <VStack width={width}>
      <Turnstile
        style={width ? { width: '100%' } : undefined}
        sitekey={siteKey}
        refreshExpired="manual"
        size={'flexible'}
        onSuccess={(token) => onSuccessHandler(token)}
        onError={() => onErrorHandler(ETurnstileErrorCode.ProtectionFailed)}
        onExpire={() => onErrorHandler(ETurnstileErrorCode.ProtectionExpired)}
        onTimeout={() => onErrorHandler(ETurnstileErrorCode.Timeout)}
        onUnsupported={() => onErrorHandler(ETurnstileErrorCode.Unsupported)}
      />
      {turnstileError && (
        <VStack marginY={'8px'} maxWidth={'360px'}>
          <Text variant={'error'} color={'extra.red'} fontWeight={'semibold'}>
            {TurnstileErrors[turnstileError].message}
          </Text>
        </VStack>
      )}
    </VStack>
  );
};

export default TurnstileWidget;
